import { ReactNode } from 'react'

export type AiAgentLayoutShadcnComponentProps = {
  children: ReactNode
}

export function AiAgentLayoutShadcnComponent({ children }: AiAgentLayoutShadcnComponentProps) {
  return <>{children}</>
}
